// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2aVJ7","sessionTitle":"styles_sessionTitle__WG1b4","username":"styles_username__3slFF","session":"styles_session__24Qkl","value":"styles_value__23Tps"};